module.exports = __webpack_public_path__ + "img/icon-bath.92c242ae.svg";